<template>
    <div class="content">
        <el-card class="box-card" shadow="never" :body-style="{ padding: '0px' }">
            <div class="chart-box itemC">
                <span class="title">人数：{{peopleNum}}</span>
                <span class="title">平均分：{{average}}</span>
                <span @click="gardeSection" class="setting el-icon-s-tools"></span>
            </div>
            <div class="resultEcharts" ref="resultEcharts">
            </div>
        </el-card>
        <div class="table-box">
            <div class="header">
                <div class="search-box"> 
                    <el-select class="search" v-model="searchField" size="medium" placeholder="请选择个人信息">
                        <el-option label="全部" value="全部"></el-option>
                        <el-option
                        v-for="(item) in searchOptions"
                        :key="item.field"
                        :label="item.title"
                        :value="item.field">
                        </el-option>
                    </el-select>
                    <el-input v-if="searchField != '全部'" class="input" size="medium"  v-model="searchValue" placeholder="请输入内容"></el-input>
                    <el-button @click="searchGetDate" type="primary" size="medium" icon="el-icon-search">搜索</el-button>
                </div>
                <div>
                    <el-button type="text" @click="toScore">待评分</el-button>
                    <el-popover
                        class="popover"
                        placement="bottom"
                        title="导出"
                        width="200"
                        trigger="click"
                        v-model="exportVisible">
                        <div>
                            <el-checkbox-group v-model="exportCheckList">
                                <el-checkbox class="checkbox" label="word">用户答卷word</el-checkbox>
                                <el-checkbox class="checkbox" label="pdf">用户答卷pdf</el-checkbox>
                                <el-checkbox class="checkbox" label="optionNumberDown">按选项序号导出</el-checkbox>
                                <el-checkbox class="checkbox" label="textDownload">按选项文本导出</el-checkbox>
                                <el-checkbox class="checkbox" label="scoreDownload">按照选项分数下载</el-checkbox>
                            </el-checkbox-group>
                        </div>
                        <div style="text-align: right; margin: 0">
                            <el-button size="mini" type="text" @click="exportVisible = false">取消</el-button>
                            <el-button type="primary" size="mini" @click="doExport">确定</el-button>
                        </div>
                        <el-button  slot="reference" type="text">导出</el-button>
                    </el-popover>
                    
                    <el-button type="text" @click="wipeData">清空数据</el-button>
                </div>
            </div>
            <el-table
                class="table"
                :data="tableData"
                height="250"
                stripe
                v-loading="loading"
                style="width: 100%"
            >
                
                <el-table-column
                    align="center"
                    v-for="(item, index) in tableTitle" :key="index"
                    :prop="item.field"
                    :label="item.title">
                </el-table-column>
                <el-table-column
                    fixed="right"
                    label="操作"
                    width="200px"
                    align="center">
                    <template slot-scope="scope">
                        <el-link @click.native.prevent="toPreview(scope.row.underwayId)" type="primary" :underline="false">预览</el-link>
                        <el-link @click.native.prevent="toRating(scope.row.underwayId)" type="primary" :underline="false">评分</el-link>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                class="pagination"
                v-if="tableData.length > 0"
                background
                @current-change="pageChange"
                layout="total, prev, pager, next"
                :total="total">
            </el-pagination>
        </div>
        <el-dialog
            title="分数段设置"
            :visible.sync="gardeDialog"
            width="30%"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            >
            <div v-for="(item, index) in scoreList" :key="index">
                <p class="score-list">
                    <el-input type="number" size="small" class="score-input" v-model.number="item.begin" placeholder="请输入分数"></el-input>
                     分 至 
                    <el-input type="number" size="small" class="score-input" v-model.number="item.end" placeholder="请输入分数"></el-input>
                     分
                    <i @click="addScoreItem" v-if="index == scoreList.length -1" class="btn el-icon-circle-plus-outline"></i>
                    <i @click="deleteScoreItem(index)" v-if="index != 0" class="btn el-icon-delete"></i>
                </p>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button size="medium" @click="gardeDialog = false">取 消</el-button>
                <el-button size="medium" type="primary" @click="doScoreSetting">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import echarts from 'echarts';
import qs from 'qs'
export default {
    name: 'ResultStats',
    data() {
        return{
            id: '',
            gardeDialog: false,
            scoreList: [{
                begin: '',
                end: ''
            }],
            searchOptions: [],
            tableData: [],
            tableTitle: [],
            searchField: '',
            searchValue: '',
            loading: false,
            pageNum: 1,
            pageSize: 10,
            total: 0,
            exportVisible: false,
            exportCheckList: [],
            average: 0,
            peopleNum: 0
        }
    },
    created() {
        this.id = sessionStorage.getItem("examId")
        this.getDate()
        
        this.getScore()
    },
    mounted() {
    },
    methods: {
        toPreview(id) {
            this.$router.push({
                name: 'UserExamPreview',
                params: {
                    id: this.id,
                    userId: id,
                    findResultParse: 1,
                    showGradeBill: 1
                }
            })
        },
        toRating(id) {
            this.$router.push({
                name: 'ExamScore',
                params: {
                    id: this.id,
                    userId: id,
                }
            })
        },
        toScore() {
            this.$router.push('/examScore')
        },
        doExport() {
            let exprotObj = {
                word: false,
                pdf: false,
                optionNumberDown: false,
                textDownload: false,
                scoreDownload: false,
                searchField: this.searchField == '全部' ? '' : this.searchField,
                searchValue: this.searchValue,
                surveyId: this.id,
            }
            for (let item in exprotObj) {
                if (this.exportCheckList.indexOf(item) != -1) {
                    exprotObj[item] = true
                }
            }
            let that = this
            let params = {
                that: this,
                url: `${this.$config.service.examGadeCountExport}`,
                method: "POST",
                data: exprotObj,
                cb(res) {
                    that.exportVisible = false
                    // console.log(res)
                    if (res.code == '0'){
                        that.exportCheckList = []
                        that.popUpPrompt()
                    }
                },
            };
            this.$util.request(params);
        },
        popUpPrompt() {
			this.$notify({
				dangerouslyUseHTMLString: true,
				message: `${this.$t('DataRecycling.DataPreparationInProgress')} 
							<a href="#" class="notify-link" id="my-download-link">
								<span style="color: blue;">${this.$t('DataRecycling.MyDownload')}</span>
							</a> 
							${this.$t('DataRecycling.CanViewProgress')}`
			});
			this.$nextTick(() => {
				const link = document.querySelector('#my-download-link');
				if (link) {
					link.addEventListener('click', (e) => {
						e.preventDefault(); // 阻止默认的链接跳转
						this.$router.push('/MyProject'); // 使用 Vue Router 跳转
					});
				}
			});
		},
        wipeData() {
            let that = this;
            this.$prompt(`您确定要清空当前数据吗?清空数据需要输入账户密码确认`, "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
                inputType: 'password',
                closeOnClickModal: false,
                closeOnPressEscape: false
            })
                .then(({ value }) => {
                    let params = {
                        that: that,
                        url: `${that.$config.service.examDeleteExamUnderway}?surveyId=${that.id}&password=${value}`,
                        method: "POST",
                        cb(res) {
                            if (res.code == 0) {
                                that.pageNum = 1
                                that.getDate()
                                that.getScore()
                                that.$message.success('清空成功！');
                            } else {
                                that.$message.error(res.message);
                            }
                        },
                    };
                    that.$util.request(params);
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消清空",
                    });
                });
            },
        pageChange(e) {
            this.pageNum = e
            this.getDate()
        },
        searchGetDate() {
            if(this.searchField == '') {
                this.$message({
                    message: '请选择要查询的个人信息',
                    type: 'warning'
                })
            } else {
                this.pageNum = 1
                this.getDate()
            }
        },
        getDate() {
            this.loading = true
            this.searchOptions = []
            let that = this
            let data = {
                pageNum: this.pageNum,
                pageSize: this.pageSize,
                surveyId: this.id
            }
            if (this.searchField && this.searchField != '全部') {
                data.searchField = this.searchField
            }
            if (this.searchValue) {
                data.searchValue = this.searchValue
            }
            let params = {                                                                  
                that: this,
                url: `${this.$config.service.examGradeCount}`,
                method: "POST",
                data: data,
                cb(res) {
                    // console.log(res)
                    that.loading = false
                    if (res.code == '0'){
                        that.tableTitle = res.resultBody.columns
                        that.tableData = res.resultBody.dataList
                        that.total = res.resultBody.count
                        res.resultBody.columns.forEach((info, index) => {
                            info.title = that.$functions.htmlFormat(info.title)
                            if (info.field != 'whenSec' && 
                                info.field != 'scoreSum' && 
                                info.field != 'ip' && 
                                info.field != 'fromDetails' && 
                                info.field != 'endExamTime'
                            ) {
                                that.searchOptions.push(info)
                            }
                        })
                    }
                },
            };
            this.$util.request(params)
        },
        getScore(){
            let that = this
            let params = {
                that: this,
                url: `${this.$config.service.examFractionalSet}?surveyId=${this.id}`,
                method: "POST",
                cb(res) {
                    // console.log(res)
                    if (res.code == '0'){
                        let numArr = [], titleArr = []
                        res.resultBody.forEach((info, index) => {
                            for(let item in info) {
                                if(item == 'count') {
                                    that.peopleNum = info[`count`]
                                }
                                if(item == 'overAvg') {
                                    that.average = info[`overAvg`]
                                }
                                if(item == 'num') {
                                    numArr.push(info[`num`])
                                }
                                if(item == 'title') {
                                    titleArr.push(info[`title`])
                                }
                            }
                        })
                        that.$nextTick(()=>{
                            let resultChart = echarts.init(that.$refs.resultEcharts)
                            // console.log(resultChart)
                            let option = {
                                    tooltip: {},
                                    
                                    xAxis: {
                                        type: 'category',
                                        data: titleArr
                                    },
                                    yAxis: {
                                        type: 'value'
                                    },
                                    series: [
                                        {
                                            data: numArr,
                                            type: 'bar',
                                            color: ['#409EFF'],
                                        }
                                    ]
                            };
                            resultChart.clear()
                            resultChart.setOption(option)
                        })
                    }
                },
            };
            this.$util.request(params)

            
        },
        getScoreSetting() {
            let that = this
            let params = {
                that: this,
                url: `${this.$config.service.examFindFractionalSet}?surveyId=${this.id}`,
                method: "POST",
                cb(res) {
                    // console.log(res)
                    if (res.code == '0'){
                        try {
                            that.scoreList = JSON.parse(res.message)
                        } catch (error) {
                            try {
                                // 如果直接解析失败，尝试修复后解析
                                const fixedJSON = that.fixJSONString(res.message)
                                that.scoreList = JSON.parse(fixedJSON)
                            } catch (fixError) {
                                console.error('JSON解析失败:', fixError)
                                console.error('原始字符串:', res.message)
                            }
                        }
                        
                        console.log('that.scoreList :>> ', that.scoreList);
                    }
                },
            };
            this.$util.request(params);
        },
        fixJSONString(jsonStr) {
            if (!jsonStr || typeof jsonStr !== 'string') {
                return jsonStr
            }
            
            // 匹配没有引号的键名：以 { 或 , 开头，后面跟着字母、数字、下划线，然后接 :
            const fixedStr = jsonStr.replace(/([{,]\s*)([a-zA-Z_$][a-zA-Z0-9_$]*)(\s*:)/g, '$1"$2"$3')
            
            return fixedStr
        },
        gardeSection() {
            this.getScoreSetting()
            this.gardeDialog = true
        },
        addScoreItem() {
            this.scoreList.push({
                begin: '',
                end: ''
            })
        },
        deleteScoreItem(index) {
            this.scoreList.splice(index, 1)
        },
        doScoreSetting() {
            let that = this
            let data = qs.stringify({
                "fractionalSet": JSON.stringify(this.scoreList),
                "surveyId": this.id,
            })
            let params = {
                that: this,
                url: `${this.$config.service.examUpdateFractionalSet}?${data}`,
                method: "POST",
                cb(res) {
                    // console.log(res)
                    if (res.code == '0'){
                        that.getScore()
                        that.gardeDialog = false
                    }
                },
            };
            this.$util.request(params);
        },
    }
}
</script>

<style scoped lang="scss">
.content{
    padding-left: 100px;
    margin-right: 20px;
    padding-top: 20px;
    min-height: calc(100vh - 80px);
    background-color: #fff;
    box-sizing: border-box;
    .chart-box{
        line-height: 37px;
        display: flex;
        justify-content: end;
        padding-right: 20px;
        box-sizing: border-box;
        background-color: #e1e5e6;
        line-height: 37px;
        .title{
            font-size: 14px;
            margin-right: 20px;
        }
        .setting{
            font-size: 18px;
            cursor: pointer;
        }
        .setting:hover {
            color: #5cb6ff;
        }
        .title::before,.setting::before{

        }
    }
    
    .resultEcharts{
        height: 300px;
    }
}

.placeholder{
    opacity: 0;
}
.itemC{
    display: flex;
    align-items: center;
}
.score-list{
    display: flex;
    align-items: center;
    margin-bottom: 14px;
    .score-input{
        width: 27%;
        margin: 0 10px;
    }
    /deep/.el-input__inner::-webkit-outer-spin-button,
    /deep/.el-input__inner::-webkit-inner-spin-button {
    -webkit-appearance: none;
    }
    .btn{
        font-size: 18px;
        display: inline-block;
        color: #ccc;
        margin-left: 10px;
        cursor: pointer;
    }
}
.table-box{
    margin-top: 20px;
    .header{
        display: flex;
        justify-content: space-between;
        align-items: center;
        .search-box{
                display: flex;
            .search,.input{
                margin-right: 10px;
                width: auto;
            }
        }
        .popover{
            margin:0 10px;
            
            
        }
    }
    .table{
        margin-top: 20px;
    }
    .pagination{
        margin-top: 40px;
        text-align: center;
    }
}
        /deep/.el-checkbox{
            padding-left: 18px;
        }
        /deep/.el-checkbox+.el-checkbox {
            margin-top: 15px;
            
        }
</style>